const ArtworkStandard = `
  id
  name
`;

export default ArtworkStandard;
